import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys, text } from "@clockwise/web-commons/src/styles/color.styles";
import { size } from "@clockwise/web-commons/src/styles/type.styles";

const container: CSSProperties = {
  width: "100%",
  flexGrow: 1,
  padding: 0,
  paddingBottom: 10,
};

const divider: CSSProperties = {
  marginTop: 20,
  marginBottom: 20,
};

const h1: CSSProperties = {
  color: colors.blueDusk.standard,
  marginBottom: 0,
  paddingTop: 24,
};

const work: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

const intro: CSSProperties = {
  color: greys.slate,
  fontSize: 14,
  lineHeight: 1.5,
};

const links: CSSProperties = {
  fontSize: size.sm,
  marginLeft: "auto",
};

const error: CSSProperties = {
  color: text.error,
  marginTop: 10,
  fontSize: 14,
};

export const styles = {
  container,
  divider,
  h1,
  work,
  intro,
  links,
  error,
};
